import { useTranslation } from 'react-i18next'

import { ServerPrivateRegionInfo } from '@/api/type-server'
import { Dropdown } from '@/components/base/Dropdown'

interface RegionSelectorProps {
  domainInfos: ServerPrivateRegionInfo[]
  selectedRegion: number | null
  setSelectedRegion: (region: number) => void
}

export function RegionSelector({
  domainInfos,
  selectedRegion,
  setSelectedRegion,
}: RegionSelectorProps) {
  const { t } = useTranslation('privateRegion')

  return (
    <Dropdown
      options={domainInfos.map((info) => ({
        label: info.name,
        value: info.region,
      }))}
      value={selectedRegion ?? ''}
      onChange={(value) => setSelectedRegion(Number(value))}
      placeholder={t('selector.selectRegion')}
      className="w-40"
      disabled={domainInfos.length === 0}
    />
  )
}
